<template>
    <div v-if="hasUser" :class="{ 'higher-contrast': needsHigherContrast }">
        <header-bar />
        <sidebar />
        <main id="content" class="content">
            <router-view v-if="hasUser" />

            <portal-target name="modals" multiple />
            <portal-target class="notification-container" name="notifications" multiple />
        </main>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobile } from '../../utilities'
import HeaderBar from './HeaderBar.vue'
import Sidebar from './Sidebar.vue'
export default {
    name: 'layout',
    components: {
        HeaderBar,
        Sidebar
    },
    head: {
        meta() {
            return [{ name: 'viewport', content: this.scale, id: 'viewport' }]
        }
    },
    computed: {
        ...mapGetters(['hasUser', 'needsHigherContrast', 'a11yMode']),
        scale() {
            if (isMobile()) {
                return 'width=device-width, initial-scale=1, maximum-scale=1'
            }
            return 'width=device-width, initial-scale=1'
        }
    },
    watch: {
        a11yMode() {
            this.$emit('updateHead')
        }
    }
}
</script>

<style lang="stylus">
    .content
        padding-left: 120px
        padding-top: 120px
        padding-right: 40px

        @media screen and (max-width: 1024px)
            padding-left: 90px
            padding-top: 110px
            padding-right: 20px

        @media screen and (max-width: 480px)
            padding-left: 5px
            padding-right: 5px
            padding-top: 80px

    .notification-container
        z-index: 99999
        position: fixed
        top: 80px
        right: 20px
</style>